// extracted by mini-css-extract-plugin
export default {"root":"LandingPage_root__YsanD","logo":"LandingPage_logo__X85G0"};